import { store } from '@store/index';
import { resetStep } from '@store/slices/login.slice';
import { getAccessToken } from '@utils/helpers';
import axios, { AxiosError } from 'axios';
import { t as translate } from 'i18next';
import { toast } from 'react-toastify';

interface ApiErrorResponse {
  error?: {
    message?: string;
    errorMessage?: string;
  };
}

const headers = {
  'Content-Type': 'application/json',
};

// Create an axios instance
// In Jest: process.env.VITE_CLIENT_SERVICE_URL is set in jest setup file
// In Vite: This will be replaced at build time by Vite's define config
const baseURL = process.env.VITE_CLIENT_SERVICE_URL || 'http://localhost:3000';

const axiosInstance = axios.create({
  baseURL,
  timeout: 50000,
  headers,
});

// Request Interception
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${getAccessToken()}`;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(undefined, (error: AxiosError) => {
  const { response } = error || {};
  const status = response?.status;

  // Show toast error message
  const errorData = response?.data as ApiErrorResponse;
  const errMsg =
    errorData?.error?.message ||
    errorData?.error?.errorMessage ||
    'Something went wrong. Please contact support.' ||
    translate('sys.api.errorMessage');
  toast.error(errMsg);

  // Handle 401 Unauthorized
  if (status === 401) {
    store.dispatch(resetStep());
    // localStorage.removeItem('accessToken'); // Optional: clear stale token
    window.location.href = '/';
    // eslint-disable-next-line no-console
    console.log('its 401 error, redirecting to login');
  }

  return Promise.reject(error);
});

export { axiosInstance };
